import { PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, Select, Space } from 'antd';

const ROLE_OPTIONS = [
  { label: 'Administrator', value: 'administrator' },
  { label: 'Standard', value: 'user' },
];

const InviteUserModal = ({ open, onCancel, onSubmit, loading, form, showRole = true }) => {
  return (
    <Modal title="Invite New User" open={open} onCancel={onCancel} footer={null} width={500}>
      <Form form={form} layout="vertical" onFinish={onSubmit}>
        <Form.Item
          label="First Name"
          name="firstName"
          rules={[{ required: true, message: 'First Name is required' }]}
        >
          <Input placeholder="First Name" />
        </Form.Item>
        <Form.Item
          label="Last Name"
          name="lastName"
          rules={[{ required: true, message: 'Last Name is required' }]}
        >
          <Input placeholder="Last Name" />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: 'Email is required' },
            { type: 'email', message: 'Invalid email format' },
          ]}
        >
          <Input placeholder="Email" />
        </Form.Item>
        {showRole && (
          <Form.Item
            label="Role"
            name="role"
            initialValue="user"
            rules={[{ required: true, message: 'Role is required' }]}
          >
            <Select placeholder="Select Role" options={ROLE_OPTIONS} />
          </Form.Item>
        )}
        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
          <Space>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit" icon={<PlusOutlined />} loading={loading}>
              Add User
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default InviteUserModal;
